"use client";
 


import React from 'react';
import { ResumeData } from '@/lib/schema';
import { MdLink, MdOutlineLocationOn, MdOutlineMailOutline, MdPhone } from 'react-icons/md';
import { FaLinkedin } from 'react-icons/fa';

// Helper function to handle both old and new language formats
const getLanguageName = (lang: string | { name: string }): string => {
  return typeof lang === 'string' ? lang : lang.name;
};

const Executive: React.FC<{ data: ResumeData }> = ({ data }) => {
  const basics = data.basics;
  const experience = data.experience || [];
  const education = data.education || [];
  const skills = data.skills || [];
  const languages = basics.languages || [];

  return (
    <div className="executive-root"
       style={{
    display: 'flex',
    
    
    // minHeight: '297mm',
    // maxHeight: '297mm',
    width: '210mm',
    fontFamily: 'serif',
    backgroundColor: '#f3f4f6',
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
  }}
    >
      {/* Main Content - Left Side */}
      <main  className="executive-main"
        style={{
          flex: '1',
          backgroundColor: '#ffffff',
          padding: '3rem',
        }}
      >
        {/* Header with Profile Image */}
        <div
          style={{
            borderBottom: '2px solid #374151',
            paddingBottom: '1rem',
            marginBottom: '1.5rem',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              flex: '1',
            }}
          >
            <h1
              style={{
                fontSize: '2.25rem',
                fontWeight: 'bold' as const,
                color: '#1f2937',
                margin: '0',
              }}
            >
              {basics.name}
            </h1>
            {basics.title && (
              <h2
                style={{
                  fontSize: '1.25rem',
                  color: '#2563eb',
                  fontWeight: 'bold' as const,
                  margin: '0.5rem 0 0.5rem 0',
                }}
              >
                {basics.title}
              </h2>
            )}
            {basics.summary && (
              <p
                style={{
                  color: '#374151',
                  fontSize: '1rem',
                  maxWidth: '50rem',
                  margin: '0',
                }}
              >
                {basics.summary}
              </p>
            )}
          </div>
          {basics.photo && (
            <div
              style={{
                marginLeft: '1.5rem',
              }}
            >
              <img
                src={basics.photo}
                alt="Profile"
                style={{
                  width: '8rem',
                  height: '8rem',
                  borderRadius: '50%',
                  border: '4px solid #d1d5db',
                  objectFit: 'cover',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                }}
              />
            </div>
          )}
        </div>

        {/* Work Experience */}
        <section
          style={{
            marginBottom: '2rem',
          }}
        >
          <h2
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              fontSize: '1.5rem',
              fontWeight: 'bold' as const,
              textTransform: 'uppercase' as const,
              color: '#1f2937',
              marginBottom: '1rem',
            }}
          >
            Experience
          </h2>
          {experience.map((exp, idx) => (
            <div
              key={idx}
              style={{
                marginBottom: '1.5rem',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div>
                  <span
                    style={{
                      fontWeight: 'bold' as const,
                      fontSize: '1.125rem',
                      color: '#374151',
                    }}
                  >
                    {exp.role}
                  </span>
                  <span
                    style={{
                      display: 'block',
                      color: '#374151',
                      fontWeight: 'medium' as const,
                    }}
                  >
                    {exp.company}
                  </span>
                </div>
                <div
                  style={{
                    textAlign: 'right' as const,
                  }}
                >
                  <span
                    style={{
                      display: 'block',
                      fontSize: '0.875rem',
                      color: '#6b7280',
                    }}
                  >
                    {exp.startDate} - {exp.current ? 'Present' : exp.endDate}
                  </span>
                </div>
              </div>
              {exp.summary && (
                <ul
                  style={{
                    listStyleType: 'disc' as const,
                    marginLeft: '1.5rem',
                    marginTop: '0.5rem',
                    color: '#374151',
                    fontSize: '0.875rem',
                  }}
                >
                  <li style={{ margin: '0' }}>{exp.summary}</li>
                </ul>
              )}
            </div>
          ))}
        </section>

        {/* Education */}
        <section>
          <h2
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              fontSize: '1.5rem',
              fontWeight: 'bold' as const,
              textTransform: 'uppercase' as const,
              color: '#1f2937',
              marginBottom: '1rem',
            }}
          >
            Education
          </h2>
          <ul
            style={{
              listStyleType: 'disc' as const,
              marginLeft: '1.5rem',
              color: '#374151',
              fontSize: '0.875rem',
            }}
          >
            {education.map((edu, idx) => (
              <li
                key={idx}
                style={{
                  marginBottom: '0.5rem',
                }}
              >
                <span
                  style={{
                    fontWeight: 'bold' as const,
                  }}
                >
                  {edu.degree}
                </span>
                <span
                  style={{
                    display: 'block',
                    fontSize: '0.75rem',
                    color: '#6b7280',
                    fontStyle: 'italic' as const,
                  }}
                >
                  {edu.institution}
                </span>
                <span
                  style={{
                    display: 'block',
                    fontSize: '0.75rem',
                    color: '#6b7280',
                  }}
                >
                  {edu.startDate} - {edu.endDate}
                </span>
              </li>
            ))}
          </ul>
        </section>
      </main>

      {/* Sidebar - Right Side */}
      <div
        style={{
       width: '72mm',
    minWidth: '72mm',
    maxWidth: '72mm',
    minHeight: '297mm', // Use minHeight
    backgroundColor: '#2d3e50',
    color: '#ffffff',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
    boxSizing: 'border-box',
        }}
        className="executive-sidebar"
      >
        {/* Contact */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
          }}
        >
          <h2
            style={{
              textTransform: 'uppercase' as const,
              fontWeight: 'bold' as const,
              fontSize: '1.125rem',
              marginBottom: '0.5rem',
              letterSpacing: '0.1em',
            }}
          >
            Contact
          </h2>
          {basics.email && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                flexWrap: 'wrap' as const,
              }}
            >
              <MdOutlineMailOutline
                style={{
                  fontSize: '1.125rem',
                }}
              />
              {basics.email}
            </div>
          )}
          {basics.phone && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
              }}
            >
              <MdPhone
                style={{
                  fontSize: '1.125rem',
                }}
              />
              {basics.phone}
            </div>
          )}
          {basics.location && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
              }}
            >
              <MdOutlineLocationOn
                style={{
                  fontSize: '1.125rem',
                }}
              />
              {basics.location}
            </div>
          )}
          {basics.social?.map((link) => {
            const icon =
              link.label.toLowerCase().includes('linkedin') ? (
                <FaLinkedin
                  style={{
                    fontSize: '1.25rem',
                  }}
                />
              ) : (
                <MdLink
                  style={{
                    fontSize: '1.25rem',
                  }}
                />
              );
            return (
              <div
                key={link.label}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  flexWrap: 'wrap' as const,
                  fontSize: '0.875rem',
                }}
              >
                {icon}
                {link.url}
              </div>
            );
          })}
        </div>

        {/* Skills */}
        <div>
          <h2
            style={{
              textTransform: 'uppercase' as const,
              fontWeight: 'bold' as const,
              fontSize: '1.125rem',
              marginBottom: '0.5rem',
              letterSpacing: '0.1em',
            }}
          >
            Skills
          </h2>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap' as const,
              gap: '0.5rem',
            }}
          >
            {skills.map((skill) => (
              <span
                key={skill}
                style={{
                  backgroundColor: '#3e5066',
                  borderRadius: '0.25rem',
                  padding: '0.25rem 0.75rem',
                  fontSize: '0.875rem',
                  whiteSpace: 'nowrap' as const,
                  flexWrap: 'wrap' as const,
                }}
              >
                {skill}
              </span>
            ))}
          </div>
        </div>

        {/* Languages */}
        {languages.length > 0 && (
          <div>
            <h2
              style={{
                textTransform: 'uppercase' as const,
                fontWeight: 'bold' as const,
                fontSize: '1.125rem',
                marginBottom: '0.5rem',
                letterSpacing: '0.1em',
              }}
            >
              Languages
            </h2>
            <ul
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.25rem',
              }}
            >
              {languages
                .map((lang) => getLanguageName(lang as string | { name: string }))
                .map((langName, idx) => (
                  <li
                    key={idx}
                    style={{
                      margin: '0',
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 'bold' as const,
                      }}
                    >
                      {langName}
                    </span>
                  </li>
                ))}
            </ul>
          </div>
        )}

        {/* Hobbies & Interests */}
        {basics.hobbies && basics.hobbies.length > 0 && (
          <div>
            <h2
              style={{
                textTransform: 'uppercase' as const,
                fontWeight: 'bold' as const,
                fontSize: '1.125rem',
                marginBottom: '0.5rem',
                letterSpacing: '0.1em',
              }}
            >
              Hobbies & Interests
            </h2>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap' as const,
                gap: '0.5rem',
              }}
            >
              {basics.hobbies.map((hobby, idx) => (
                <span
                  key={idx}
                  style={{
                    backgroundColor: '#3e5066',
                    borderRadius: '0.25rem',
                    padding: '0.25rem 0.75rem',
                    fontSize: '0.875rem',
                    whiteSpace: 'nowrap' as const,
                  }}
                >
                  {hobby}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Strengths Section - Only show if data exists */}
        {basics.strengths && basics.strengths.length > 0 && (
          <div>
            <h2
              style={{
                textTransform: 'uppercase' as const,
                fontWeight: 'bold' as const,
                fontSize: '1.125rem',
                marginBottom: '0.5rem',
                letterSpacing: '0.1em',
              }}
            >
              Strengths
            </h2>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
              }}
            >
              {basics.strengths.map((strength, idx) => (
                <div
                  key={idx}
                  style={{
                    margin: '0',
                  }}
                >
                  <span
                    style={{
                      fontWeight: 'bold' as const,
                      fontSize: '0.875rem',
                    }}
                  >
                    {strength.title}
                  </span>
                  {strength.description && (
                    <p
                      style={{
                        fontSize: '0.75rem',
                        color: '#d1d5db',
                        marginTop: '0.25rem',
                      }}
                    >
                      {strength.description}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Key Achievements Section - Only show if data exists */}
        {basics.achievements && basics.achievements.length > 0 && (
          <div>
            <h2
              style={{
                textTransform: 'uppercase' as const,
                fontWeight: 'bold' as const,
                fontSize: '1.125rem',
                marginBottom: '0.5rem',
                letterSpacing: '0.1em',
              }}
            >
              Key Achievements
            </h2>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
              }}
            >
              {basics.achievements.map((achievement, idx) => (
                <div
                  key={idx}
                  style={{
                    margin: '0',
                  }}
                >
                  <span
                    style={{
                      fontWeight: 'bold' as const,
                      fontSize: '0.875rem',
                    }}
                  >
                    {achievement.title}
                  </span>
                  {achievement.description && (
                    <p
                      style={{
                        fontSize: '0.75rem',
                        color: '#d1d5db',
                        marginTop: '0.25rem',
                      }}
                    >
                      {achievement.description}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
        <style jsx>{`
      @media print {
         html, body, #__next, .print-content {
    width: 210mm !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }
  .executive-sidebar {
    position: fixed !important;
    left: 0;
    top: 0;
    width: 72mm !important;
    height: 297mm !important;
    background: #2d3e50 !important;
    color: white !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    z-index: 10;
  }
  .executive-main {
    margin-left: 72mm !important;
    width: 138mm !important; /* 210mm - 72mm */
  }
  .executive-root {
    width: 210mm !important;
    min-height: 297mm !important;
    background: #f3f4f6 !important;
    box-sizing: border-box !important;
  }
 
    
  @page {
    size: A4;
    margin: 0;
  }
      }

        

    `}</style>
    </div>
  );
};

export default Executive;